import { ApplicationConfig, importProvidersFrom, PLATFORM_ID, TransferState } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { provideAngularSvgIcon, SvgLoader } from 'angular-svg-icon';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { reducers } from '@smarttask-app/src/app/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbCustomDateParserFormatter } from '@smarttask-common/src/lib/services/BootstrapSpecific/ngbCustomDateParserFormatter';
import { NgbDateTimeService } from '@smarttask-common/src/lib/services/BootstrapSpecific/ngbDateTime.service';
import { provideToastr } from 'ngx-toastr';
import { CustomToastComponent } from '@smarttask-app/src/app/area/customToast/customToast';
import { isPlatformServer, provideImgixLoader } from '@angular/common';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { svgLoaderFactory } from '@smarttask-common/src/lib/services/SvgIcon/svg-loader-factory';
import { SvgBrowserLoader } from '@smarttask-common/src/lib/services/SvgIcon/svg-browser.loader';

export const appConfig: ApplicationConfig = {
    providers: [
        provideClientHydration(),
        provideHttpClient(withFetch()),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({
                paramsInheritanceStrategy: 'always',
                onSameUrlNavigation: 'reload',
            }),
            withInMemoryScrolling({
                anchorScrolling: 'enabled',
                scrollPositionRestoration: 'enabled',
            }),
        ),
        provideStore(reducers, {
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: false,
            },
        }),
        provideStoreDevtools({
            maxAge: 25, // Retains last 25 states
        }),
        {
            provide: NgbDateAdapter,
            useClass: NgbDateNativeAdapter, //For conversion from DateStruct to native JS Date
        },
        {
            provide: NgbDateParserFormatter,
            useClass: NgbCustomDateParserFormatter,
        },
        NgbDateTimeService,
        provideToastr({
            positionClass: 'toast-bottom-left',
            toastComponent: CustomToastComponent,
        }),
        provideAngularSvgIcon({
            loader: {
                provide: SvgLoader,
                useFactory: (http: HttpClient, transfer_state) => new SvgBrowserLoader(http, transfer_state),
                deps: [HttpClient, TransferState],
            },
        }),
        provideAnimationsAsync(),

        provideImgixLoader('https://images.prismic.io/smarttask/'),
        provideLottieOptions({
            player: () => player,
        }),
    ],
};
